import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PageRequest} from '../../core/pagination/page-request';
import {SignaalkaartAntwoord} from '../signaalkaart-antwoord';
import {Page} from '../../core/pagination/page';
import {SortOrder} from '../../core/sort/sort-order';
import {Signaalkaart} from '../signaalkaart';
import {Signaalkaarten} from '../signaalkaarten';

@Component({
    selector: 'zah-signaalkaart-antwoorden',
    templateUrl: './signaalkaart-antwoorden.component.html',
    styleUrls: ['./signaalkaart-antwoorden.component.scss'],
    standalone: false
})
export class SignaalkaartAntwoordenComponent implements OnInit {

  @Input()
  initialPageRequest: PageRequest<SignaalkaartAntwoord>;
  @Input()
  signaalkaartAntwoordenPage: Page<SignaalkaartAntwoord>;
  @Input()
  signaalkaarten: Signaalkaarten;
  @Output()
  signaalkaartAntwoordClicked: EventEmitter<SignaalkaartAntwoord> = new EventEmitter<SignaalkaartAntwoord>();
  @Output()
  pageChange: EventEmitter<PageRequest<SignaalkaartAntwoord>> = new EventEmitter<PageRequest<SignaalkaartAntwoord>>();

  private currentPageRequest: PageRequest<SignaalkaartAntwoord>;

  ngOnInit(): void {
    this.currentPageRequest = this.initialPageRequest;
  }

  onSignaalkaartAntwoordClick(signaalkaartAntwoord: SignaalkaartAntwoord): void {
    this.signaalkaartAntwoordClicked.emit(signaalkaartAntwoord);
  }

  onSortOrderChange(sortOrder: SortOrder): void {
    this.currentPageRequest = PageRequest.firstPageRequest<SignaalkaartAntwoord>(sortOrder, this.currentPageRequest.getPageSize());
    this.pageChange.emit(this.currentPageRequest);
  }

  onPageSizeChange(pageSize: number): void {
    this.currentPageRequest = PageRequest.firstPageRequest<SignaalkaartAntwoord>(this.currentPageRequest.getSortOrder(), pageSize);
    this.pageChange.emit(this.currentPageRequest);
  }

  onPageChange(pageRequest: PageRequest<SignaalkaartAntwoord>): void {
    this.currentPageRequest = pageRequest;
    this.pageChange.emit(pageRequest);
  }

  getSignaalkaart(id: string, versie: number): Signaalkaart {
    return this.signaalkaarten.getSignaalkaartWithIdAndVersie(id, versie);
  }
}
